/** A selected object always belongs to an immutable revision in the address. */
export interface DraftView {
  revision?: string;
  programOperation?: string;
  inspectionOperation?: string;
  sessionId?: string;
  objectPath?: string;
  node?: number;
  after?: number;
  feedbackCursor?: string;
}

export function draftView(search: Record<string, unknown>): DraftView {
  const { revision, objectPath, node, after, feedbackCursor, sessionId, programOperation, inspectionOperation } = search;
  if (revision !== undefined && (typeof revision !== "string" || !/^[0-9a-f]{64}$/.test(revision))) throw new Error("The preview revision must be a SHA-256 digest.");
  if (objectPath !== undefined && (typeof objectPath !== "string" || objectPath.split("/").length > 64 || !objectPath.split("/").every((part) => /^[0-9a-f]{64}$/.test(part)))) throw new Error("The object address must contain a known asset path.");
  for (const index of [node, after]) {
    if (index !== undefined && (typeof index !== "number" || !Number.isInteger(index) || index < 0 || index >= 10000)) throw new Error("The object index is invalid.");
  }
  if ((objectPath !== undefined && revision === undefined) || ((node !== undefined || after !== undefined) && objectPath === undefined)) throw new Error("Choose a revision and asset before selecting an object.");
  if (feedbackCursor !== undefined && (typeof feedbackCursor !== "string" || !/^(0|[1-9][0-9]{0,19})$/.test(feedbackCursor) || BigInt(feedbackCursor) > 18446744073709551615n)) throw new Error("The feedback page cursor is invalid.");
  if (sessionId !== undefined && (typeof sessionId !== "string" || sessionId.length < 1 || sessionId.length > 512 || revision === undefined)) throw new Error("An inspection session needs its revision.");
  for (const operation of [programOperation, inspectionOperation]) {
    if (operation !== undefined && (typeof operation !== "string" || operation.length < 1 || operation.length > 512)) throw new Error("The saved work address is invalid.");
  }
  return { revision, objectPath, node, after, feedbackCursor, sessionId, programOperation, inspectionOperation } as DraftView;
}
